if (!customElements.get("rv-overlay")) {

    class RvOverlay extends HTMLElement {

        constructor() {
            super();

            this.backdrop = null;
            this.panel = null;

            this.currentView = null;

            this.timeline = gsap.timeline({
                paused: true
            });

            this.handleKeydown = this.handleKeydown.bind(this);
        }


        /* =========================
           CONNECTED
        ========================= */

        connectedCallback() {

            this.backdrop =
                this.querySelector(
                    "rv-overlay-backdrop"
                );

            this.panel =
                this.querySelector(
                    "rv-overlay-panel"
                );

            document.addEventListener("keydown", this.handleKeydown);
        }

        disconnectedCallback() {
            document.removeEventListener("keydown", this.handleKeydown);
        }

        handleKeydown(event) {
                if (event.key !== "Escape") return;
                this.close();
        }

        /* =========================
           GET VIEW
        ========================= */

        getView(viewName) {

            let view =
                this.panel.querySelector(
                    `[data-overlay-view="${viewName}"]`
                );


            /*
             * If the view doesn't exist,
             * create it.
             */

            if (!view) {

                view =
                    document.createElement("div");

                view.className =
                    "overlay-view";

                view.dataset.overlayView =
                    viewName;

                this.panel.appendChild(view);

            }


            return view;

        }


        /* =========================
           SET CONTENT
        ========================= */

        setContent(viewName, content) {

            const view =
                this.getView(viewName);


            /*
             * Replace only the content
             * of this view.
             */

            view.replaceChildren(content);


            return view;

        }


        /* =========================
           OPEN
        ========================= */

        open(viewName) {

            const view =
                this.getView(viewName);


            /*
             * Hide previous view
             */

            if (this.currentView) {

                this.currentView
                    .classList
                    .remove("is-active");

            }


            /*
             * Show requested view
             */

            view.classList.add(
                "is-active"
            );


            this.currentView =
                view;


            /*
             * Check breakpoint
             */

            const isMobile =
                window.matchMedia(
                    "(max-width: 767px)"
                ).matches;


            /*
             * Make overlay visible
             */
            

            this.style.visibility =
                "visible";
            
            document.body.style.overflow = "hidden";

            /*
             * Prepare animation
             */

            this.timeline
                .clear()

                .set(this.backdrop, {
                    opacity: 0
                })

                .set(this.panel, {
                    x: isMobile
                        ? 0
                        : "100%",

                    y: isMobile
                        ? "100%"
                        : 0
                });


            /*
             * OPEN
             */

            this.timeline

                .to(this.backdrop, {
                    opacity: 1,
                    duration: 0.3
                })

                .to(this.panel, {
                    x: 0,
                    y: 0,
                    duration: 0.5,
                    ease: "power3.out"
                }, "<")

                .play();

        }


        /* =========================
           CLOSE
        ========================= */

        close() {

            const isMobile =
                window.matchMedia(
                    "(max-width: 767px)"
                ).matches;


            this.timeline
                .clear()


                /*
                 * PANEL OUT
                 */

                .to(this.panel, {

                    x: isMobile
                        ? 0
                        : "100%",

                    y: isMobile
                        ? "100%"
                        : 0,

                    duration: 0.4,

                    ease: "power3.in"

                })


                /*
                 * BACKDROP OUT
                 */

                .to(this.backdrop, {

                    opacity: 0,

                    duration: 0.3

                }, "<")


                /*
                 * HIDE
                 */

                .set(this, {

                    visibility: "hidden"

                })

                .set(document.body, {
                    
                    overflow: "auto"
                })

                .play();

        }


        /* =========================
           GO
        ========================= */

        go(
            viewName,
            direction = "forward"
        ) {

            const nextView =
                this.getView(viewName);


            /*
             * Nothing to transition from
             */

            if (!this.currentView) {

                this.open(viewName);

                return;

            }


            /*
             * Same view
             */

            if (
                nextView ===
                this.currentView
            ) {

                return;

            }


            const currentView =
                this.currentView;


            /*
             * FORWARD
             *
             * current → left
             * next    ← right
             *
             *
             * BACK
             *
             * current → right
             * next    ← left
             */

            const nextX =
                direction === "back"
                    ? "-100%"
                    : "100%";


            const currentX =
                direction === "back"
                    ? "30%"
                    : "-30%";


            /*
             * Show next view
             */

            nextView.classList.add(
                "is-active"
            );


            /*
             * Prepare next view
             */

            this.timeline
                .clear()

                .set(nextView, {

                    x: nextX,

                    opacity: 1

                })


                /*
                 * CURRENT OUT
                 */

                .to(currentView, {

                    x: currentX,

                    opacity: 0,

                    duration: 0.3,

                    ease: "power2.in"

                })


                /*
                 * NEXT IN
                 */

                .to(nextView, {

                    x: 0,

                    opacity: 1,

                    duration: 0.4,

                    ease: "power3.out"

                }, "<")


                /*
                 * CLEANUP
                 */

                .set(currentView, {

                    clearProps:
                        "transform,opacity"

                })

                .set(nextView, {

                    clearProps:
                        "transform,opacity"

                })


                /*
                 * UPDATE CURRENT VIEW
                 */

                .call(() => {

                    currentView
                        .classList
                        .remove("is-active");

                    this.currentView =
                        nextView;

                })


                .play();

        }

    }


    customElements.define(
        "rv-overlay",
        RvOverlay
    );

}



/* =================================
   GLOBAL TRIGGER HANDLER
================================= */

document.addEventListener(
    "click",
    async (event) => {


        /* =========================
           OPEN
        ========================= */

        const openTrigger =
            event.target.closest(
                "[data-overlay-open]"
            );

        if (openTrigger) {
            if (openTrigger.dataset.state == "opening"){
                return;
            }

            openTrigger.dataset.state="opening";

            const overlayId =
                openTrigger.dataset
                    .overlayOpen;


            const viewName =
                openTrigger.dataset
                    .overlayView;


            const overlay =
                document.getElementById(
                    overlayId
                );


            if (!overlay) {
                return;
            }


            /*
             * TEMPLATE
             */

            const template =
                openTrigger.querySelector(
                    "template"
                );


            if (template) {

                const content =
                    template.content.cloneNode(
                        true
                    );


                overlay.setContent(
                    viewName,
                    content
                );

            }


            /*
             * FETCH
             */

            const url =
                openTrigger.dataset
                    .overlayUrl;


            if (url) { 
                openTrigger.dataset.state == "loading";

                try {

                    const response =
                        await fetch(url);


                    if (!response.ok) {

                        throw new Error(
                            `HTTP ${response.status}`
                        );

                    }


                    const html =
                        await response.text();


                    const content =
                        document
                            .createRange()
                            .createContextualFragment(
                                html
                            );


                    overlay.setContent(
                        viewName,
                        content
                    );

                }

                catch (error) {

                    console.error(
                        "Overlay fetch failed:",
                        error
                    );

                    return;

                }finally{
                    delete openTrigger.dataset.state;
                }

            }


            /*
             * OPEN
             */

            overlay.open(
                viewName
            );

            if (!url){
                delete openTrigger.dataset.state;
            }

            return;

        }



        /* =========================
           CLOSE
        ========================= */

        const closeTrigger =
            event.target.closest(
                "[data-overlay-close]"
            );


        if (closeTrigger) {

            const overlay =
                closeTrigger.closest(
                    "rv-overlay"
                );


            overlay?.close();


            return;

        }



        /* =========================
           GO
        ========================= */

        const goTrigger =
    event.target.closest(
        "[data-overlay-go]"
    );

if (goTrigger) {

    const overlay =
        goTrigger.closest(
            "rv-overlay"
        );

    if (!overlay) return;


    const viewName =
        goTrigger.dataset.overlayGo;


    const direction =
        goTrigger.dataset.overlayDirection ||
        "forward";


    const url =
        goTrigger.dataset.overlayUrl;


    /*
     * Fetch content if URL exists
     */

    if (url) {
        goTrigger.dataset.state= "loading";

        try {

            const response =
                await fetch(url);

            if (!response.ok) {
                throw new Error(
                    `HTTP ${response.status}`
                );
            }

            const html =
                await response.text();

            const content =
                document
                    .createRange()
                    .createContextualFragment(
                        html
                    );

            overlay.setContent(
                viewName,
                content
            );

        } catch (error) {

            console.error(
                "Overlay fetch failed:",
                error
            );

            return;

        } finally{
            delete goTrigger.dataset.state
        }

    }

const template =
                goTrigger.querySelector(
                    "template"
                );


            if (template) {

                const content =
                    template.content.cloneNode(
                        true
                    );


                overlay.setContent(
                    viewName,
                    content
                );
            }
    /*
     * Now transition
     */

    overlay.go(
        viewName,
        direction
    );

}

    }
);